<script setup lang="ts">
definePageMeta({
  layout: 'blank',
});
defineProps<{ error: any }>();
</script>
<template>
  <div class="d-flex justify-center align-center text-center h-100">
    <div>
      <img
        src="~/public/images/backgrounds/errorimg.svg"
        width="500"
        alt="404"
      />
      <h1 class="text-h1 pt-3">{{ $t('opps') }}</h1>
      <h4 class="text-h4 my-8">
        {{ $t('thisPageYouAreLookingForCouldNotBeFound') }}
      </h4>
      <v-btn rounded="pill" color="primary" class="mb-4" to="/">{{
        $t('goBackToHome')
      }}</v-btn>
    </div>
  </div>
</template>
